import { ActionTypes } from './constants';
import { ModalOptions } from '.';

const initialState: ModalOptions = {
    visible: false
};

export default (state = initialState, action: any) => {
    switch (action.type) {
        case ActionTypes.MODAL_SHOW:
            return { ...state, ...action.options, visible: true };
        case ActionTypes.MODAL_HIDE:
            return { ...state, ...action.options, visible: false };
        default:
            return state;
    }
};
